/**
=========================================================
* Material Kit 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MKInput
import MKInputRoot from "components/MKInput/MKInputRoot";

const MKInput = forwardRef(
  ({ size, error, success, disabled, autocomplete, date, ...rest }, ref) => (
    <MKInputRoot
      {...rest}
      ref={ref}
      ownerState={{ size, autocomplete, date, error, success, disabled }}
    />
  )
);

// Setting default values for the props of MKInput
MKInput.defaultProps = {
  size: "medium",
  error: false,
  success: false,
  disabled: false,
  autocomplete: false,
  date: false,
};

// Typechecking props for the MKInput
MKInput.propTypes = {
  error: PropTypes.bool,
  success: PropTypes.bool,
  disabled: PropTypes.bool,
  autocomplete: PropTypes.bool,
  date: PropTypes.bool,
};

export default MKInput;
